module.exports = __webpack_public_path__ + "static/media/empty_rsvp.a89a2430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/empty_rsvp.png
// module id = 1048
// module chunks = 49